import { render, staticRenderFns } from "./FilterCategories.vue?vue&type=template&id=6c063b4c&scoped=true&"
import script from "./FilterCategories.vue?vue&type=script&lang=js&"
export * from "./FilterCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c063b4c",
  null
  
)

export default component.exports